import { render, staticRenderFns } from "./lookUp.vue?vue&type=template&id=05a12235&scoped=true"
import script from "./lookUp.vue?vue&type=script&lang=ts"
export * from "./lookUp.vue?vue&type=script&lang=ts"
import style0 from "./lookUp.vue?vue&type=style&index=0&id=05a12235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a12235",
  null
  
)

export default component.exports